import React from 'react';
import PropTypes from 'prop-types';
import './ExplanationStep.css';

/**
 * PersonalExplanationStep Component
 *
 * Explains what the personal readiness assessment evaluates before starting questions.
 */
const PersonalExplanationStep = ({ onNext, onPrev }) => {
  return (
    <div className="explanation-step">
      <div className="explanation-container">
        <h1 className="explanation-title">Personal Readiness Assessment</h1>

        <p className="explanation-intro">
          The next 15 questions evaluate your personal preparation for exiting your business.
        </p>

        <div className="explanation-content">
          <h2>What We'll Assess</h2>

          <div className="explanation-grid">
            <div className="explanation-card">
              <h3>Financial Planning</h3>
              <p>Post-exit goals, investment strategy, cash flow planning, and wealth management readiness</p>
            </div>

            <div className="explanation-card">
              <h3>Estate & Tax Planning</h3>
              <p>Estate plan documentation, tax optimization, beneficiary alignment, and trust structures</p>
            </div>

            <div className="explanation-card">
              <h3>Life Vision & Purpose</h3>
              <p>Post-exit vision clarity, sense of purpose, identity beyond business, and new activities</p>
            </div>

            <div className="explanation-card">
              <h3>Family & Relationships</h3>
              <p>Family communication, lifestyle transition planning, and support system alignment</p>
            </div>

            <div className="explanation-card">
              <h3>Emotional Readiness</h3>
              <p>Preparedness to let go, transition confidence, and excitement for next chapter</p>
            </div>
          </div>

          <div className="explanation-how-it-works">
            <h2>How It Works</h2>
            <ul>
              <li><strong>Rate each question</strong> on a scale of 1-6 based on your current level of preparation</li>
              <li><strong>Read the guidance</strong> provided for each question - click the 💡 Rule of Thumb and 📋 Why This Matters sections</li>
              <li><strong>Be honest with yourself</strong> - personal readiness is just as important as business readiness for a successful exit</li>
              <li><strong>Questions auto-save</strong> - you can pause and return anytime</li>
            </ul>
          </div>

          <div className="explanation-note">
            <strong>⏱️ Time Required:</strong> Approximately 5-7 minutes for 15 questions
          </div>
        </div>

        <div className="explanation-actions">
          <button onClick={onPrev} className="btn-secondary">
            ← Back
          </button>
          <button onClick={onNext} className="btn-primary">
            Start Personal Assessment →
          </button>
        </div>

        {/* Copyright Footer */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <div className="assessment-footer">
            © 2025 Dominion Business Advisors LLC. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

PersonalExplanationStep.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired
};

export default PersonalExplanationStep;
